export const border = {
  radius: {
    lg: '12px',
    md: '8px',
    sm: '4px',
    xl: '32px',
    xs: '3px',
    xxl: '42px',
  },
};

export const colors = {
  backdrop: 'rgba(47, 19, 89, 0.3)',
  backgroundGrey: '#F4F3F6',
  backgroundGreyHighlight: 'rgba(244, 243, 246, 0.4)',
  black: '#000',
  button: {
    iconAndText: {
      default: {
        background: 'transparent',
        border: 'transparent',
        text: '#6D5A8B',
      },
      disabled: { background: '#DADCDF', border: '#DADCDF', text: '#8D959C' },
      hover: { background: '#EAE7EE', border: '#EAE7EE', text: '#6D5A8B' },
    },
    primary: {
      default: { background: '#6515DD', text: '#FFFFFF' },
      disabled: { background: '#EAE7EE', text: '#C1B8CD' },
      hover: { background: '#935BE7', text: '#FFFFFF' },
    },
    stroke: {
      default: { background: '#FFFFFF', border: '#6515DD', text: '#6515DD' },
      disabled: { background: '#EAE7EE', text: '#C1B8CD' },
      hover: { background: '#F0E8FC', border: '#6515DD', text: '#6515DD' },
    },
  },
  darkGrey: '#6E7175',
  disabled: '#DADCDF',
  error: '#FF4F4F',
  errorHighlight: '#FFCACA',
  errorTint: '#FF8484',
  graphColors: [
    '#00DEDE',
    '#6515DD',
    '#FBB81A',
    '#2F1359',
    '#FF4F4F',
    '#2F1359',
    '#E5FCFC',
    '#F0E8FC',
    '#FEEABA',
    '#EAE7EE',
    '#FFEDED',
  ],
  grey: '#8D959C',
  iconBackgrounds: [
    '#2bcec8',
    '#fe4f9e',
    '#fdc772',
    '#ab94ef',
    '#7686e7',
    '#4d4299',
  ],
  lavender: '#74729D',
  lightGrey: '#EDEEF0',
  primary: '#6515DD',
  primaryHighlight: '#F0E8FC',
  primaryTint: '#7C38E2',
  quarternary: '#9789AC',
  quarternaryTint: 'rgba(244, 243, 246, 0.1)',
  secondary: '#2F1359',
  secondaryHighlight: '#E9E2FF',
  secondaryTint: '#43266D',
  success: '#00C8C8',
  successHighlight: '#A0EEEE',
  successTint: '#00DEDE',
  teal: '#00DEDE',
  tertiary: '#5C73DA',
  tertiaryDarken: '#140F3E',
  tertiaryHighlight: '#ECEFFF',
  tertiaryTint: '#7187ED',
  text: {
    primary: '#000',
    secondary: '#5C73DA',
    tertiary: '#fff',
  },
  warning: '#FBB81A',
  warningHighlight: '#FEEABA',
  white: '#FFF',
};

export const font = {
  family: 'Muli, sans-serif',
  lineHeight: {
    lg: '26px',
    md: '24px',
    sm: '18px',
    xl: '29px',
    xs: '16px',
    xxl: '48px',
  },
  size: {
    lg: '21.5px',
    md: '16.5px',
    sm: '15px',
    xl: '24px',
    xs: '13.5px',
    xxl: '38px',
    xxs: '11.5px',
    xxxl: '48px',
  },
  weight: {
    bold: 700,
    extraBold: 800,
    light: 300,
    normal: 400,
    semibold: 600,
  },
};

export const gradients = {
  primary:
    'linear-gradient(187.72deg, #FE3F33 6.05%, #4B38BD 39.1%, #43A5F6 75.59%)',
  secondary: `linear-gradient(254.95deg, ${colors.success} -3.65%, ${colors.primary} 98.61%)`,
};

export const maxMobileWidth = 1023;
export const minTabletWidth = 1024;
export const maxTabletWidth = 1366;
export const minDesktopWidth = 1367;

export const responsive = {
  mobile: `@media screen and (max-width: ${maxMobileWidth}px)`,
  tablet: `@media screen and (min-width: ${minTabletWidth}px) and (max-width: ${maxTabletWidth}px)`,
};

export const shadows = {
  primary: '0px 4px 10px rgba(138, 138, 138, 0.15)',
  quarternary: '0px 0px 6px rgba(0, 0, 0, 0.1)',
  secondary: '0px 2px 6px 0px rgba(0, 0, 0, 0.04)',
  tertiary: '0px 6px 10px rgba(138, 138, 138, 0.35)',
};

export const spacing = {
  lg: '32px',
  md: '24px',
  sm: '12px',
  xl: '48px',
  xs: '8px',
  xxl: '64px',
  xxs: '4px',
  xxxl: '96px',
  xxxs: '2px',
};

export const windowSize = {
  height: `${window.innerHeight}px`,
  isDesktop: window.innerWidth >= minDesktopWidth,
  isMobile: window.innerWidth <= maxMobileWidth,
  isTablet:
    window.innerWidth <= maxTabletWidth && window.innerWidth >= minTabletWidth,
  width: `${window.innerWidth}px`,
};
